import { DEFAULT_TRAFFIC_COLOR } from '../const';

/**
 * Парсер елемента element-element
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-image-element.json
 * @param  {Object} element
 * @return {Object}
 */
export default (function (element) {
    if (!element) {
        return null;
    }

    var _element$score = element.score,
        score = _element$score === undefined ? '' : _element$score,
        _element$text = element.text,
        text = _element$text === undefined ? '' : _element$text,
        _element$color = element.color,
        color = _element$color === undefined ? DEFAULT_TRAFFIC_COLOR : _element$color;


    if (!score) {
        return null;
    }

    return {
        color: color,
        score: score,
        text: text
    };
});